(function () {
    'use strict';

    angular.module("imApp").factory("dbStationService", ['$ihttp', function ($ihttp) {
        let service = {
            getDbStation: function (parms) {
                return $ihttp.post({
                    method: 2298,
                    parameters: parms || {}
                });
            },
            testAccessToken: function (edit) {
                return $ihttp.post({
                    method: 2301,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2300,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
